import { useEffect, useRef, useState } from "react";
import "./styles.css";
import Props from "prop-types";

const ConsentFragmentForm = ({
  setSelectedCheckboxes,
  setIsRequiredSelected,
  controller_code,
  customer_scope,
  language,
}) => {
  const consentFormRef = useRef(null);
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConsentFragment = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${import.meta.env.VITE_DOMAIN}/${controller_code}/${customer_scope}/${language}/cs/consent_fragment`,
        );
        const html = await response.text();

        setHtmlContent(html);
        setError(null);
      } catch (err) {
        setError("Failed to load consent fragment");
        console.error("Error fetching consent fragment:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConsentFragment();
  }, []);

  useEffect(() => {
    const container = consentFormRef.current;
    if (!container) return;
    const removeAllCheckSection = container.querySelector(
      ".truman-consent-fragment.remove-all-check",
    );
    if (removeAllCheckSection) {
      const checkboxes = removeAllCheckSection.querySelectorAll(
        'input[type="checkbox"]',
      );
      checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
    }
  }, [htmlContent]);

  useEffect(() => {
    const container = consentFormRef.current;
    if (!container) return;
    const handleChange = (e) => {
      if (e?.target?.id?.startsWith("check-group")) {
        let groupChildren = e.target
          .closest(".truman-group-checkbox")
          .querySelectorAll(".group-child input[type='checkbox']");
        if (e.target.checked) {
          groupChildren.forEach((child) => {
            child.checked = true;
          });
        } else {
          groupChildren.forEach((child) => {
            child.checked = false;
          });
        }
      }
      const checkedCheckboxes = container.querySelectorAll(
        'input[type="checkbox"]:checked',
      );
      if (setSelectedCheckboxes) setSelectedCheckboxes(checkedCheckboxes);
      validateRequiredCheckboxes();
    };

    container.addEventListener("change", handleChange);
    handleChange();
    return () => {
      container.removeEventListener("change", handleChange);
    };
  }, [htmlContent]);

  const validateRequiredCheckboxes = () => {
    const requiredCheckboxes =
      consentFormRef.current?.querySelectorAll(
        'input[type="checkbox"][required]',
      ) || [];

    const allChecked =
      requiredCheckboxes.length > 0
        ? [...requiredCheckboxes].every((cb) => cb.checked)
        : true;
    const checkedCheckboxes = consentFormRef.current?.querySelectorAll(
      'input[type="checkbox"]:checked',
    );

    if (setIsRequiredSelected)
      setIsRequiredSelected(allChecked && checkedCheckboxes.length > 0);
  };

  if (loading) return <div className="formContainer">Loading...</div>;
  if (error) return <div className="formContainer">{error}</div>;

  return (
    <div className="formContainer">
      <div
        ref={consentFormRef}
        className="consentContent"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </div>
  );
};

export default ConsentFragmentForm;

ConsentFragmentForm.propTypes = {
  setSelectedCheckboxes: Props.func,
  setIsRequiredSelected: Props.func,
  controller_code: Props.string,
  customer_scope: Props.string,
  language: Props.string,
};
